import type { LessonRequestType, LessonRequestStatus, LessonRequestCandidateStatus, LessonRequestEventType } from "api/types/lesson-request.types";

type BadgeVariant = "active" | "pending" | "rejected" | "draft" | "info" | "default";

// 1-1. request_type (수업 종류) 라벨
export const LESSON_REQUEST_TYPE_LABEL: Record<LessonRequestType, string> = {
  TRIAL: "체험 다이빙",
  REGULAR: "강습권 개설(일반강습)",
  PREMIUM: "프리미엄 트레이닝",
  SPECIAL: "스페셜 트레이닝 개설",
};

// 1-2. status (요청 상태) 라벨
export const LESSON_REQUEST_STATUS_LABEL: Record<LessonRequestStatus, string> = {
  PENDING: "대기",
  CONFIRMED: "예약 확정",
  OPENED: "수업 오픈",
  REJECTED: "거절",
  EXPIRED: "만료",
  CANCELLED: "취소",
};

// 1-2. status → Badge variant 매핑
export const LESSON_REQUEST_STATUS_BADGE: Record<LessonRequestStatus, BadgeVariant> = {
  PENDING: "pending",
  CONFIRMED: "active",
  OPENED: "active",
  REJECTED: "rejected",
  EXPIRED: "draft",
  CANCELLED: "draft",
};

// 상태 필터 Select 옵션 (전체 + 6개 상태)
export const LESSON_REQUEST_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "상태 전체" },
  ...(Object.keys(LESSON_REQUEST_STATUS_LABEL) as LessonRequestStatus[]).map((value) => ({
    value,
    label: LESSON_REQUEST_STATUS_LABEL[value],
  })),
];

// 1-3. candidate.status (후보 강사 상태) 라벨
export const CANDIDATE_STATUS_LABEL: Record<LessonRequestCandidateStatus, string> = {
  NOTIFIED: "통지됨",
  SEEN: "열람",
  ACCEPTED: "수락",
  REJECTED: "거절",
  CLOSED: "마감(다른 강사가 먼저 수락)",
  EXPIRED: "만료",
};

// 1-3. candidate.status → Badge variant 매핑
export const CANDIDATE_STATUS_BADGE: Record<LessonRequestCandidateStatus, BadgeVariant> = {
  NOTIFIED: "info",
  SEEN: "info",
  ACCEPTED: "active",
  REJECTED: "rejected",
  CLOSED: "draft",
  EXPIRED: "draft",
};

// 1-4. event_type (타임라인 이벤트) 라벨
export const EVENT_TYPE_LABEL: Record<LessonRequestEventType, string> = {
  CREATED: "요청 생성",
  REJECTED_BY_CANDIDATE: "개별 강사 거절",
  ACCEPTED: "강사 수락",
  REJECTED: "후보 전원 거절 → 최종 거절",
  EXPIRED: "만료",
  CANCELLED: "수강생 취소",
  UPDATED: "요청 수정",
};

// 기간 빠른 선택 프리셋 (신청일 created_at 기준)
export type PeriodPreset = "1w" | "1m" | "3m" | "custom";

export const PERIOD_PRESETS: { value: PeriodPreset; label: string }[] = [
  { value: "1w", label: "최근 1주" },
  { value: "1m", label: "최근 1개월" },
  { value: "3m", label: "최근 3개월" },
  { value: "custom", label: "직접 입력" },
];
